import {Text} from '#component/base';
import {anchorNames} from '#component/page/HealthFactorAssessment/HealthFactorAssessment.util';
import {Markdown} from '#component/partial';

import * as css from './HealthFactorRecommendations.css';

export const HealthFactorRecommendations = ({
  title,
  description,
}: {
  title: string;
  description: string;
}) => {
  return (
    <div className={css.root} id={anchorNames.whatToDo}>
      <Text variant="heading2" as="h2" color="burgundy" className={css.title}>
        {title}
      </Text>
      <Markdown data={description} className={css.description} />
    </div>
  );
};
